'use strict';

var Inflections = require('../var/Inflections');

function runHumanRules(str) {
  // istanbul ignore next
  return Inflections.human && Inflections.human.runRules(str) || str;
}

module.exports = runHumanRules;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/runHumanRules.js
// module id = 458
// module chunks = 0